<template>
  <div class="sub_title">
    <div class="left">
      <img :src="img" alt="">
      <h3 :class="type==1?'sub_title_major':'sub_title_major sub_title_majorFont'">
        {{ name }}
      </h3>
      <div v-if="isShow" class="title_test">(排名不分先后)</div>
    </div>
    <span class="right" @click="handleRightClick" v-if="rbtn">
      {{ rbtn }}
    </span>
  </div>
</template>
<script>
export default {
  name: "SubTitle",
  props: {
    img: {
      type:String,
      default:()=>{
        return require("@/assets/images/yellowabc.png")
      }
    },
    name: "",
    rbtn: "",
    type:{
      type:Number,
      default:1,
    },
    isShow:{
      type:Boolean,
      default:false,
    }
  },
  methods: {
    handleRightClick() {
      this.$emit("setRightClick");
    },
  },
};
</script>
<style lang="scss" scoped>
.sub_title {
  line-height: 1;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    img{
      // width: 61px;
    }
    .sub_title_major{
      font-size: 36px;
      font-weight: 400;
      color: #1d4434;
      margin-left: 21px;

    }
    .sub_title_majorFont{
      font-size: 30px;
    }
    .title_test{
      font-size: 14px;
      font-weight: 400;
      color: #1d4434;
      margin-left: 10px;
      margin-top: 15px;
    }
  }
  .right {
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    width: 118px;
    height: 34px;
    background: #1D4434;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    // padding-bottom: 10px;
    &:hover{
      // text-decoration:underline;
    }
  }

}
</style>
